import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { IoMdClose } from "react-icons/io";

import "./style.css";
import Button from "../button";
import { rewriteStringwithCaps } from "../../utils/utility";

interface DialogProps {
  open: boolean;
  handleClose: () => void;
  submit?: () => void;
  title?: string | React.ReactNode;
  cancelTitle?: string;
  submitTitle?: string;
  children?: React.ReactNode;
  loading?: boolean;
  showFooter?: boolean;
  handleCancel?: () => void;
}

const DialogContainer = (props: DialogProps) => {
  return (
    <Dialog
      className="product-dialog-container"
      open={props.open}
      maxWidth={"sm"}
      onClose={props.handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      slotProps={{ backdrop: { className: "product-dialog-backdrop" } }}
    >
      <div className="dialog-heading">
        {props.title}
        <button
          className="close-btn"
          onClick={props.handleClose}
          data-track="close-button"
        >
          <IoMdClose className="close-icon" />
        </button>
      </div>
      <DialogContent className="dialog-content">{props.children}</DialogContent>
      {props.showFooter && (
        <DialogActions className="dialog-footer">
          <Button
            customClass={props.cancelTitle ? "cancel-btn-border" : "cancel-btn"}
            submit={props.handleCancel ? props.handleCancel : props.handleClose}
            label={props.cancelTitle ? props.cancelTitle : "Cancel"}
            data-track="cancel-button"
          />
          <Button
            label={rewriteStringwithCaps(
              props.submitTitle ? props.submitTitle : "Submit"
            )}
            customClass="checkout-btn"
            loader={props.loading}
            loadingText="Processing"
            submit={props.submit}
            data-track="submit-button"
          />
        </DialogActions>
      )}
    </Dialog>
  );
};

export default DialogContainer;
